import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';
import { radioDescriptionVariants, radioLabelVariants } from './logic';
import styles from './styles.module.scss';

type RadioSize = 'medium' | 'regular';

/**
 * Radix UIのラジオグループ
 *
 * @see https://www.radix-ui.com/primitives/docs/components/radio-group
 */
const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitive.Root ref={ref} className={className} {...props} />
));

type RadioProps = Omit<
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>,
  'children'
> & {
  /** ラジオボタンのサイズ（テキストサイズが変わる） */
  size?: RadioSize;
  /** ラベルテキスト */
  label: string;
  /** 説明テキスト */
  description?: string;
};

const Radio = React.forwardRef<React.ElementRef<typeof RadioGroupPrimitive.Item>, RadioProps>(
  ({ className, size = 'regular', label, description, ...props }, ref) => {
    const id = props.id ?? props.value;

    return (
      <div className={styles.radioWrapper}>
        <div className={styles.radioRow}>
          <RadioGroupPrimitive.Item
            ref={ref}
            id={id}
            className={`${styles.radio} ${className || ''}`}
            {...props}
          >
            <RadioGroupPrimitive.Indicator className={styles.radioIndicator} />
          </RadioGroupPrimitive.Item>
          <label htmlFor={id} className={radioLabelVariants({ size })}>
            {label}
          </label>
        </div>
        {description && <span className={radioDescriptionVariants({ size })}>{description}</span>}
      </div>
    );
  }
);
Radio.displayName = 'Radio';

export type { RadioProps, RadioSize };
export { Radio, RadioGroup };
